// @ts-nocheck
import React from 'react';
import { Box } from '@mui/material';
import PhoneInput from 'components/__v2__/PhoneInput';
import FieldWithDecimalControlled from 'components/__v2__/FieldWithDecimalControlled';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';

const NumberFormFieldPreview = ({
  element,
  answer,
  handleAnswerChange,
  shouldBeReadOnly,
}) => (
  <Box key={element?.id} m={1}>
    <FieldsInputTitle
      label={element?.label || element?.name}
      isRequired={element?.isRequired}
    />
    {element?.type === 'phone' ? (
      <PhoneInput
        value={answer}
        onChange={(value) => handleAnswerChange({ target: { value } })}
        readOnly={shouldBeReadOnly}
      />
    ) : (
      <FieldWithDecimalControlled
        id={element?.id}
        value={answer}
        onChange={handleAnswerChange}
        variant="outlined"
        placeholder="Your Answer"
        readOnly={shouldBeReadOnly}
      />
    )}
  </Box>
);

export default NumberFormFieldPreview;
